import cookies from 'js-cookie'
import { gotoInSystemLink } from '@/utils/utils'
export default {
  autoLogin({ dispatch, state }, regUrl) {
    let url = state.route.query.redirect
    if (regUrl) {
      url = regUrl
    }
    dispatch('authentication/getSnsLoginUrl', {
      provider: 'vipmall',
      redirectUri: location.origin + `/logincallback?nxturl=${url}`,
      state: Math.floor(Math.random() * 10000)
    }).then(response => {
      window.location.href = response.data.loginUrl
    })
  },
  saveLogin({ dispatch, state }, { code, token, nxturl }) {
    if (code) {
      dispatch('paycoTokenLoginForWEB', { code, nxturl })
    } else {
      alert(`일시적으로 접속이 원활하지 않습니다.
      다시 접속해주세요.`)
    }
  },
  async afterLogined({ dispatch, state }, { nxturl }) {
    const res = await dispatch('profile/memberFetch')
    const memberNo = res.memberNo
    cookies.set('memberNo', memberNo)
    let url = nxturl || '/'
    const memberStatus = res.memberStatus
    if (memberStatus !== 'ACTIVE') {
      gotoInSystemLink('/member/agreement?nxturl=' + url)
    } else {
      await dispatch('authentication/fetchShopAgreement')
      if (opener) {
        opener.location.replace(url)
        self.close()
      } else {
        location.replace(url)
      }
    }
  },
  paycoCertify({ dispatch, state }, { nxturl }) {
    dispatch('profile/paycoSync').then(() => {
      window.location.href = nxturl
    })
  }
}
